import IconeSemInformacaoIntimacao from '@/components/IconeSemInformacaoIntimacao';
import ApmVars from '@/util/ApmVars';
import SentryUtil from '@/util/SentryUtil';
import VistaMesa from '@mui/icons-material/LocalLibrary';
import IconeAnotacoes from '@mui/icons-material/Notes';
import Warning from '@mui/icons-material/Warning';
import { Box, Chip, Tooltip, Typography } from '@mui/material';
import { blue, grey } from '@mui/material/colors';
import { action, computed, makeObservable, observable, runInAction } from 'mobx';
import { inject, observer } from 'mobx-react';
import '../../css/listaProcessos.css';
import Configuracao from '../../util/Configuracao';
import IconeDivergencia from '../IconeDivergencia';
import IconeEnviadoAoPJe from '../IconeEnviadoAoPJe';
import IconeInclusaoConfirmadaPauta from '../IconeInclusaoConfirmadaPauta';
import IconeOrigem from '../IconeOrigem';
import IconeRessalva from '../IconeRessalva';
import IconeSituacaoCertidaoJulgamento from '../IconeSituacaoCertidaoJulgamento';
import IconeSituacaoPublicacao from '../IconeSituacaoPublicacao';
import LabelNumeroProcesso from '../LabelNumeroProcesso';
import PopoverSecretaria from '../PopoverSecretaria';
import ReactComponent from '../ReactComponent';
import AnotacaoCurtaSecretario from './AnotacaoCurtaSecretario';
import Apregoar from './Apregoar';
import IconeAdvogadoPreferencia from './icones/IconeAdvogadoPreferencia';
import IconeAjustarVoto from './icones/IconeAjustarVoto';
import IconeCorreJunto from './icones/IconeCorreJunto';
import IconeDestaque from './icones/IconeDestaque';
import IconeTipoJulgamento from './icones/IconeTipoJulgamento';
import IconeTipoRemessaJulgamento from './icones/IconeTipoRemessaJulgamento';
import IconesMagistradosProcesso from './IconesMagistradosProcesso';
import Impedimento from './Impedimento';
import NovaDecisaoOuDespacho from './NovaDecisaoOuDespacho';
import OrdemSecretario from './OrdemSecretario';
import ParticipacaoAdvogado from './ParticipacaoAdvogado';
import PeticoesPendentes from './PeticoesPendentes';
import ResultadoJulgamento from './ResultadoJulgamento';
import SequenciaPreferencia from './SequenciaPreferencia';
import SituacaoAcordao from './SituacaoAcordao';
import StatusMinuta from './StatusMinuta';
import VotoNaoLiberado from './VotoNaoLiberado';
import VotoRevogado from './VotoRevogado';

class CabecalhoProcesso extends ReactComponent {
    acabouDeClicarEmFecharVistaEmMesa = false;
    abrirPopoverVistaMesa = false;

    constructor(props) {
        super(props);

        makeObservable(this, {
            acabouDeClicarEmFecharVistaEmMesa: observable,
            abrirPopoverVistaMesa: observable,
            registro: computed,
            processo: computed,
            handleClickObservacao: action,
            handleClickVistaMesa: action,
            handleCloseVistaMesa: action,
            handleDeleteVistaMesa: action,
            origemPJe: computed,
            podeApregoar: computed,
            mensagemImpossibilidadeApregoamento: computed,
            handleExpandClick: action,
            renderSequenciaPreferencia: computed,
            renderNumeroProcesso: computed,
            renderMagistradosProcesso: computed,
            renderToolbarParticipacaoAdvogado: computed,
            renderIcones: computed,
            renderApregoar: computed,
            renderNumeroPauta: computed,
            renderPreferenciaPJe: computed,
            renderPreferencia: computed,
            renderAnotacoes: computed,
            renderAnotacaoCurtaEOrdemSecretario: computed,
            renderVistaEmMesa: computed
        });
    }

    get registro() {
        return this.observableProps.registro;
    }

    get processo() {
        return this.registro.processo;
    }

    handleClickObservacao = () => {
        this.store.processoExpandido = this.registro;
    };

    handleClickVistaMesa = (event) => {
        if (!this.acabouDeClicarEmFecharVistaEmMesa) {
            this.abrirPopoverVistaMesa = true;
            this.anchorEl = event.currentTarget;
        }
    };

    handleCloseVistaMesa = () => {
        this.acabouDeClicarEmFecharVistaEmMesa = true;
        setTimeout(
            () =>
                runInAction(() => {
                    this.acabouDeClicarEmFecharVistaEmMesa = false;
                }),
            10
        );
        this.abrirPopoverVistaMesa = false;
        this.anchorEl = null;
    };

    handleDeleteVistaMesa = async () => {
        let retorno = await this.sessaoService.excluirVistaMesa(
            this.registro.sessaoId,
            this.registro.processo.numeroCompleto
        );
        if (!retorno) {
            runInAction(() => {
                this.abrirPopoverVistaMesa = false;
                this.registro.informacaoProcessoSalaSessao.magistradoVistaEmMesa = null;
                this.sessaoStore.atualizarListaProcessos();
            });

            this.mensagemStore.abrirMensagemSucesso('Pedido de vista em mesa excluído com sucesso.');
        }
    };

    get origemPJe() {
        return this.registro?.processo?.origem === Configuracao.ORIGEM_PJE;
    }

    get podeApregoar() {
        return this.salaSessaoStore.isPermitidaApreciacaoProcesso(this.registro);
    }

    get mensagemImpossibilidadeApregoamento() {
        return this.registro.necessitaImportacaoSalaSessao
            ? 'Processo não importado para sala de sessão.'
            : 'Apenas sessões com status "INICIADA" permitem apregoar processos.';
    }

    handleExpandClick = (event) => {
        if (this.registro?.numeroProcesso) {
            ApmVars.setTagNumeroProcesso(this.registro.numeroProcesso);
            SentryUtil.setScope();
        }

        if (event.target.getAttribute('data-expand')) {
            if (this.store.processoExpandido === this.registro) {
                const elemento = document.getElementById('detalhes-processo');

                if (elemento !== null) {
                    elemento.focus();
                }
            }

            this.store.processoExpandido = this.registro;
        }
    };

    render() {
        return (
            <Box
                data-expand
                onClick={this.handleExpandClick}
                style={{ display: 'flex', flexDirection: 'column', margin: '0px 5px 5px 5px', marginTop: '4px' }}
            >
                <div
                    data-expand
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        flexWrap: 'wrap',
                        fontSize: '11pt',
                        marginBottom: '6px',
                        lineHeight: 2.5
                    }}
                >
                    {this.renderSequenciaPreferencia}
                    {this.renderApregoar}
                    {this.renderNumeroProcesso}
                    {this.renderMagistradosProcesso}
                </div>
                <div
                    data-expand
                    style={{ display: 'flex', flexWrap: 'wrap' }}
                >
                    <div
                        data-expand
                        style={{ display: 'flex', alignItems: 'center', lineHeight: 2 }}
                    >
                        {this.renderNumeroPauta}
                        {this.renderToolbarParticipacaoAdvogado}
                        {this.renderPreferencia}
                        {this.renderAnotacoes}
                        {this.renderAnotacaoCurtaEOrdemSecretario}
                    </div>
                    {this.renderIcones}
                </div>
            </Box>
        );
    }

    get renderSequenciaPreferencia() {
        return this.registro.sessaoId && <SequenciaPreferencia registro={this.registro} />;
    }

    get renderNumeroProcesso() {
        return (
            <span style={{ width: '300px', marginLeft: '8px' }}>
                <LabelNumeroProcesso
                    habilitarCopiarNumero
                    registro={this.registro}
                />
            </span>
        );
    }

    get renderMagistradosProcesso() {
        return <IconesMagistradosProcesso registro={this.registro} />;
    }

    get renderToolbarParticipacaoAdvogado() {
        return (
            <div style={{ width: '130px', marginLeft: '10px' }}>
                <ParticipacaoAdvogado registro={this.registro} />
            </div>
        );
    }

    get renderIcones() {
        return (
            <div
                data-expand
                style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    flexGrow: 1,
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginLeft: '5px',
                    marginTop: '5px'
                }}
            >
                <div style={{ display: 'flex', alignItems: 'center', width: '36px' }}>
                    {this.parametroStore.isOrgaoTST && <IconeOrigem processo={this.processo} />}
                </div>
                {this.renderVistaEmMesa}
                <Impedimento registro={this.registro} />
                <div style={{ width: '28px', marginLeft: '4px' }}>
                    <PeticoesPendentes registro={this.registro} />
                </div>
                <div style={{ width: '28px', marginLeft: '4px' }}>
                    <NovaDecisaoOuDespacho registro={this.registro} />
                </div>
                <div style={{ width: '28px', marginLeft: '4px' }}>
                    <IconeDestaque registro={this.registro} />
                </div>
                <div style={{ height: '28px', width: '28px', marginLeft: '8px' }}>
                    <IconeTipoJulgamento
                        permiteAlterar={true}
                        registro={this.registro}
                    />
                </div>
                <div style={{ height: '28px', width: '34px', marginLeft: '8px' }}>
                    <IconeTipoRemessaJulgamento registro={this.registro} />
                </div>
                <div style={{ width: '28px', marginLeft: '4px' }}>
                    <IconeCorreJunto processo={this.processo} />
                </div>
                <div style={{ height: '28px', width: '28px' }}>
                    <VotoNaoLiberado registro={this.registro} />
                </div>
                <div style={{ width: '28px', marginLeft: '4px' }}>
                    <StatusMinuta registro={this.registro} />
                </div>
                <div style={{ width: '28px', marginLeft: '8px' }}>
                    <ResultadoJulgamento registro={this.registro} />
                </div>
                <div style={{ width: '28px', marginLeft: '4px' }}>
                    {this.parametroStore.isOrgaoTST && <IconeEnviadoAoPJe registro={this.registro} />}
                </div>
                <div style={{ width: '28px' }}>
                    <IconeRessalva registro={this.registro} />
                </div>
                <div style={{ width: '28px' }}>
                    <IconeDivergencia registro={this.registro} />
                </div>
                <div style={{ width: '28px' }}>
                    <VotoRevogado registro={this.registro} />
                </div>
                <div style={{ width: '28px' }}>
                    <IconeSituacaoCertidaoJulgamento registro={this.registro} />
                </div>
                <div style={{ width: '28px' }}>
                    <SituacaoAcordao registro={this.registro} />
                </div>
                <div style={{ width: '28px' }}>
                    <IconeAjustarVoto registro={this.registro} />
                </div>
                {this.isPautaJulgamento && (
                    <>
                        <div style={{ width: '28px' }}>
                            <IconeSemInformacaoIntimacao registro={this.registro} />
                        </div>
                        <div style={{ width: '28px' }}>
                            <IconeInclusaoConfirmadaPauta registro={this.registro} />
                        </div>
                        <div style={{ width: '28px' }}>
                            <IconeSituacaoPublicacao registro={this.registro} />
                        </div>
                    </>
                )}
            </div>
        );
    }

    get renderApregoar() {
        return this.isSalaSessao ? (
            <div style={{ height: '26px', marginLeft: '8px' }}>{this.verificaPodeApregoar()}</div>
        ) : (
            this.registro.necessitaImportacaoSalaSessao && (
                <div style={{ height: '26px', marginLeft: '8px' }}>
                    <Tooltip
                        title="Processo não importado para sala de sessão."
                        placement="top"
                    >
                        <Warning style={{ fill: 'darkorange' }} />
                    </Tooltip>
                </div>
            )
        );
    }

    verificaPodeApregoar() {
        return this.podeApregoar ? (
            <Apregoar
                registro={this.registro}
                exibirBotaoDetalhePregao
            />
        ) : (
            <Tooltip
                title={this.mensagemImpossibilidadeApregoamento}
                placement="top"
            >
                <Warning style={{ fill: 'darkorange' }} />
            </Tooltip>
        );
    }

    get renderNumeroPauta() {
        return this.origemPJe ? (
            <Tooltip title="Número de inclusão em pauta">
                <Typography
                    variant="h6"
                    data-expand
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        marginRight: '6px',
                        fontSize: '12pt',
                        whiteSpace: 'nowrap',
                        minWidth: '34px',
                        justifyContent: 'center',
                        cursor: 'default'
                    }}
                >
                    {this.registro.informacoesAdicionais.NumeroPauta === '0'
                        ? ''
                        : this.registro.informacoesAdicionais.NumeroPauta}
                </Typography>
            </Tooltip>
        ) : (
            <span style={{ width: '40px' }}></span>
        );
    }

    get renderPreferenciaPJe() {
        return this.registro.preferencia && <IconeAdvogadoPreferencia sx={{ mt: '10px' }} />;
    }

    get renderPreferencia() {
        const seqPref = this.registro?.pedidoSustentacaoOral?.sequenciaDigitacao
            ? this.registro.pedidoSustentacaoOral.sequenciaDigitacao
            : '';

        return (
            <div style={{ width: '36px' }}>
                {this.origemPJe ? (
                    this.renderPreferenciaPJe
                ) : (
                    <Tooltip title="Sequencial de preferência original">
                        <Typography
                            variant="h6"
                            data-expand
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                padding: '0px 5px 3px 5px',
                                fontSize: '12pt',
                                whiteSpace: 'nowrap',
                                minWidth: '36px',
                                justifyContent: 'center',
                                cursor: 'default',
                                color: grey[900],
                                opacity: '0.8'
                            }}
                        >
                            {seqPref}
                        </Typography>
                    </Tooltip>
                )}
            </div>
        );
    }

    get renderAnotacoes() {
        return (
            <div style={{ marginLeft: '5px', width: '26px' }}>
                {this.registro?.informacaoProcessoSalaSessao?.complementoAnotacoes && (
                    <Tooltip title={'Anotações: ' + this.registro.informacaoProcessoSalaSessao.complementoAnotacoes}>
                        <span>
                            <IconeAnotacoes
                                style={{ fillOpacity: '0.4' }}
                                onClick={this.handleClickObservacao}
                            />
                        </span>
                    </Tooltip>
                )}
            </div>
        );
    }

    get renderAnotacaoCurtaEOrdemSecretario() {
        return (
            this.registro.sessaoId && (
                <>
                    <div style={{ marginLeft: '5px' }}>
                        <AnotacaoCurtaSecretario
                            registro={this.registro}
                            componenteExibicao="CabecalhoProcesso"
                        />
                    </div>
                    <div style={{ marginLeft: '5px' }}>
                        <OrdemSecretario
                            registro={this.registro}
                            componenteExibicao="CabecalhoProcesso"
                        />
                    </div>
                </>
            )
        );
    }

    get renderVistaEmMesa() {
        return (
            <div style={{ width: '28px' }}>
                {this.registro?.informacaoProcessoSalaSessao?.magistradoVistaEmMesa?.sigla ? (
                    <>
                        <Box onClick={this.handleClickVistaMesa}>
                            <Tooltip
                                title={
                                    'Vista em mesa: ' +
                                    this.registro.informacaoProcessoSalaSessao.magistradoVistaEmMesa.sigla
                                }
                            >
                                <VistaMesa style={{ fillOpacity: '0.7', margin: '3px', color: blue[900] }} />
                            </Tooltip>
                        </Box>
                        {this.abrirPopoverVistaMesa && (
                            <PopoverSecretaria
                                open={this.abrirPopoverVistaMesa}
                                onClose={this.handleCloseVistaMesa}
                                anchorEl={this.anchorEl}
                            >
                                <Typography
                                    variant="h6"
                                    color="primary"
                                    style={{ margin: '6px' }}
                                >
                                    Vista em Mesa
                                </Typography>
                                <Chip
                                    style={{ marginBottom: '6px' }}
                                    label={this.registro.informacaoProcessoSalaSessao.magistradoVistaEmMesa.sigla}
                                    onDelete={this.handleDeleteVistaMesa}
                                />
                            </PopoverSecretaria>
                        )}
                    </>
                ) : (
                    ''
                )}
            </div>
        );
    }
}

export default inject('stores')(observer(CabecalhoProcesso));
